<script>
export default {
  name: 'DynamicStyle',
  render(createElement, context) {
    return createElement('style', this.$slots.default)
  }
}
</script>
